import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  InputGroup,
  InputGroupText,
} from "reactstrap"

import { FiEye, FiEyeOff } from "react-icons/fi"; 
// Redux
import { withRouter, Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

//Social Media Imports
import { GoogleLogin } from "react-google-login"
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"

// actions
import { loginUser, socialLogin } from "../../store/actions"

// import images
import logo from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"

//Import config
import { facebook, google } from "../../config"

import SweetAlert from "react-bootstrap-sweetalert"
import axios from "../../axios"
import { useHistory } from "react-router-dom"
import useNavigate from "react-use-navigate"
import { FormGroup, TextField } from "@material-ui/core"
import Select from "react-select"
import loginbg from "../../images/loginbg.jpg"


// const Login = (props) => {

//   const validation = useFormik({
//     // enableReinitialize : use this flag when initial values needs to be changed
//     enableReinitialize: true,

//     initialValues: {
//       email: "admin@themesbrand.com" || '',
//       password: "123456" || '',
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().required("Please Enter Your Email"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),
//     onSubmit: (values) => {
//        dispatch(loginUser(values, props.history));
//     }
//   });

//   const { error } = useSelector(state => ({
//     error: state.Login.error,
//   }));

//   const signIn = (res, type) => {

//     if (type === "google" && res) {

//       const postData = {
//         name: res.profileObj.name,
//         email: res.profileObj.email,
//         token: res.tokenObj.access_token,
//         idToken: res.tokenId,
//       }
//       dispatch(socialLogin(postData, props.history, type));
//     } else if (type === "facebook" && res) {

//       const postData = {
//         name: res.name,
//         email: res.email,
//         token: res.accessToken,
//         idToken: res.tokenId,
//       }
//       dispatch(socialLogin(postData, props.history, type))
//     }
//   }

//   //handleGoogleLoginResponse
//   const googleResponse = response => {
//     signIn(response, "google")
//   }

//   //handleFacebookLoginResponse
//   const facebookResponse = response => {
//     signIn(response, "facebook")
//   }

//   useEffect(() => {
//     document.body.className = "authentication-bg";
//     // remove classname when component will unmount
//     return function cleanup() {
//       document.body.className = "";
//     };
//   });

//   return (
//     <React.Fragment>
//       <div className="account-pages my-5 pt-sm-5">
//         <Container>
//           <Row>
//             <Col lg={12}>
//               <div className="text-center">
//                 <Link to="/" className="mb-5 d-block auth-logo">
//                   <img src={logo} alt="" height="22" className="logo logo-dark" />
//                   <img src={logolight} alt="" height="22" className="logo logo-light" />
//                 </Link>
//               </div>
//             </Col>
//           </Row>
//           <Row className="align-items-center justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card>
//                 <CardBody className="p-4">
//                   <div className="text-center mt-2">
//                     <h5 className="text-primary">Welcome Back !</h5>
//                     <p className="text-muted">Sign in to continue to Minible.</p>
//                   </div>
//                   <div className="p-2 mt-4">
//                     <Form
//                       className="form-horizontal"
//                       onSubmit={(e) => {
//                         e.preventDefault();
//                         validation.handleSubmit();
//                         return false;
//                       }}
//                     >
//                        {error ? <Alert color="danger">{error}</Alert> : null}

//                        <div className="mb-3">
//                         <Label className="form-label">Email</Label>
//                         <Input
//                           name="email"
//                           className="form-control"
//                           placeholder="Enter email"
//                           type="email"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.email || ""}
//                           invalid={
//                             validation.touched.email && validation.errors.email ? true : false
//                           }
//                         />
//                         {validation.touched.email && validation.errors.email ? (
//                           <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3">
//                       <div className="float-end">
//                           <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
//                         </div>
//                         <Label className="form-label">Password</Label>
//                         <Input
//                           name="password"
//                           value={validation.values.password || ""}
//                           type="password"
//                           placeholder="Enter Password"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           invalid={
//                             validation.touched.password && validation.errors.password ? true : false
//                           }
//                         />
//                         {validation.touched.password && validation.errors.password ? (
//                           <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="form-check">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customControlInline"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customControlInline"
//                         >
//                           Remember me
//                         </label>
//                       </div>

//                       <div className="mt-3">
//                         <button
//                           className="btn btn-primary w-100 waves-effect waves-light"
//                           type="submit"
//                         >
//                           Log In
//                         </button>
//                       </div>

//                       <div className="mt-4 text-center">
//                         <h5 className="font-size-14 mb-3">Sign in with</h5>

//                         <ul className="list-inline">
//                           <li className="list-inline-item">
//                             <FacebookLogin
//                               appId={facebook.APP_ID}
//                               autoLoad={false}
//                               callback={facebookResponse}
//                               render={renderProps => (
//                                 <Link
//                                 to="#"
//                                   className="social-list-item bg-primary text-white border-primary"
//                                   onClick={renderProps.onClick}
//                                 >
//                                   <i className="mdi mdi-facebook" />
//                                 </Link>
//                               )}
//                             />
//                           </li>
//                           {google.CLIENT_ID !== '' &&
//                           <li className="list-inline-item">
//                             <GoogleLogin
//                               clientId={google.CLIENT_ID}
//                               render={renderProps => (
//                                 <Link
//                                 to="#"
//                                   className="social-list-item bg-danger text-white border-danger"
//                                   onClick={renderProps.onClick}
//                                 >
//                                   <i className="mdi mdi-google" />
//                                 </Link>
//                               )}
//                               onSuccess={googleResponse}
//                               onFailure={() => {}}
//                             />
//                           </li>
//                           }
//                         </ul>
//                       </div>

//                       <div className="mt-4 text-center">
//                         <p className="mb-0">Don&apos;t have an account ? <a href="/register" className="fw-medium text-primary"> Signup now </a> </p>
//                       </div>

//                     </Form>

//                   </div>
//                 </CardBody>
//               </Card>
//               <div className="mt-5 text-center">
//                 <p>© {new Date().getFullYear()} Minible. Crafted with <i
//                   className="mdi mdi-heart text-danger"></i> by Themesbrand
//                         </p>
//               </div>
//             </Col>
//           </Row>

//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

const Login = () => {
  const dispatch = useDispatch()
  // const dispatch = useDispatch();

  const [loginfaild, setloginfaild] = useState(false)

  const [companyhelp, setcompanyhelp] = useState([])
  const [Companyvalue, setCompanyvalue] = useState({})
  const [showPassword,setShowPassword] = useState(false)

  const [logininitialize, setlogininitialize] = useState({
    usercode: "",
    password: "",
  })

  //  const navigate = useNavigate();

  const history = useHistory()
  const data = () => {
    history.push("/testing")
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: logininitialize,
    validationSchema: Yup.object({
      usercode: Yup.string().min(0).required("Please Enter User Code"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async values => {
      console.log("working")
      await axios.instance
        .post(
          `/UserLogin?usercode=${validation.values.usercode}&pass=${validation.values.password}`
        )
        .then(res => {
          console.log(res.data, "login")
          if (res.data.length !== 0) {
            for (const data of res.data) {
              console.log(res.data,'login')
              localStorage.setItem('username',data.userName)
              localStorage.setItem('UserId',data.userId)
              localStorage.setItem('isAuthUser',"true")
            }
            history.push("/testing")
          } else {
            setloginfaild(true)
            localStorage.setItem("isAuthUser", "false")
          }

          // dispatch(loginUser(values, props.history));
        })
      validation.resetForm()
      setlogininitialize({
        usercode: "",
        password: "",
        // company:''
      })
    },
  })

  localStorage.setItem("User", validation.values.usercode)

  // const { error } = useSelector(state => ({
  //   error: state.Login.error,
  // }));

  // const signIn = (res, type) => {

  //   if (type === "google" && res) {

  //     const postData = {
  //       name: res.profileObj.name,
  //       email: res.profileObj.email,
  //       token: res.tokenObj.access_token,
  //       idToken: res.tokenId,
  //     }
  //     dispatch(socialLogin(postData, props.history, type));
  //   } else if (type === "facebook" && res) {

  //     const postData = {
  //       name: res.name,
  //       email: res.email,
  //       token: res.accessToken,
  //       idToken: res.tokenId,
  //     }
  //     dispatch(socialLogin(postData, props.history, type))
  //   }
  // }

  //handleGoogleLoginResponse
  // const googleResponse = response => {
  //   signIn(response, "google")
  // }

  //handleFacebookLoginResponse
  // const facebookResponse = response => {
  //   signIn(response, "facebook")
  // }

  // useEffect(() => {
  //   document.body.className = "authentication-bg";
  //   // remove classname when component will unmount
  //   return function cleanup() {
  //     document.body.className = "";
  //   };
  // });

  useEffect(() => {
    companyMst()
  }, [])

  const companyMst = async () => {
    await axios.instance.get("CompanyHelp/GetCompany").then(res => {
      const data = res.data
      const option = data.map(row => ({
        label: row.company,
        value: row.companyId,
      }))
      //  console.log(option.slice(0,1),"companyhelp");
      setcompanyhelp(option)
      const selectedcompany = option.slice(0, 1)
      for (const data of selectedcompany) {
        setCompanyvalue({ label: data.label, value: data.value })
        localStorage.setItem(
          "company",
          JSON.stringify({ label: data.label, value: data.value })
        )
      }
    })
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: 'transparent',  // Transparent background
      border: 'none',  // No border
      borderBottom: '2px solid #6c8fc2',  // Light blue bottom border
      color: 'white',  // White text color
      fontWeight: 'bold',  // Bold font
      padding: '10px 0',
      width: '100%',
      outline: 'none',  // Remove outline
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'rgba(255, 255, 255, 0.6)',  // Light white placeholder text
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#fff',  // White background for the dropdown
      borderRadius: '4px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#848a91' : 'transparent',  // Selected option background
      color: state.isSelected ? 'black' : '#333',  // Text color for selected vs non-selected
      padding: '10px',
      cursor: 'pointer',  // Make cursor a pointer on hover
      '&:hover': {
        backgroundColor: '#f0f0f0',  // Light grey background on hover
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white',  // White color for selected value
    }),
  };

  return (
    <>
      <Container fluid className='vh-100 m-0 p-0' 
     >
        <Row className='h-100 m-0'  >
          <Col className='h-100 p-0 ' md={7} lg={5} xl={4}  >
            <Card
              className=" shadow-lg h-100 " style={{backgroundColor:"#181930" , paddingLeft:"10px" , paddingRight:"10px",}}
            >
              <CardBody className="p-4 " style={{ 
              fontFamily: "Helvetica Neue, Helvetica, Arial",
             
              
              }}>
                <div >
                  <h1 style={{ color: "white", 
                  fontSize:"40px" ,  
                  paddingTop:"50px" ,
                  fontWeight:"bold",
                   fontFamily:"'Arial', Helvetica, sans-serif"
                   
                  }}>
                    TARGET ERP
                  </h1>
                  <h4 style={{ color: "#888b11" , fontSize:"28px" , paddingBottom:"15px" }}>Sign in</h4>
                </div>
                {/* <div className="text-center mt-2">
                    <h5 className="text-primary">Welcome Back !</h5>
                    <p className="text-muted">Sign in to continue to Minible.</p>
                  </div> */}
                <div className="p-2 ">
                  {/* <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    > */}
                  {/* {error ? <Alert color="danger">{error}</Alert> : null} */}

                  <div className="mb-4" style={{ opacity: 1 }}>
                    <Label className="form-label" style={{ fontSize: "19px", fontWeight: "bold", color: "white" }}>User Code</Label>
                    <Input
                      name="usercode"
                      className="login-input"
                      type="text"
                      autoComplete="off"
                      placeholder="Enter user code"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.usercode}
                      invalid={
                        validation.touched.usercode && validation.errors.usercode ? true : false
                      }
                    />
                    {validation.touched.usercode &&
                    validation.errors.usercode ? (
                      <FormFeedback type="invalid">
                        {validation.errors.usercode}
                      </FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-4" style={{ opacity: 1 }}>
                    {/* <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                        </div> */}
                  <Label className="form-label" style={{ fontSize: "19px", fontWeight: "bold", color: "white" }}>Password</Label>
                   <InputGroup>
                    <Input
                      name="password"
                      className="login-input"
                      value={validation.values.password}
                      type={ showPassword ? "text" :"password" }
                      placeholder="Enter password"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.password &&
                        validation.errors.password
                          ? true
                          : false
                      }
                    />
                   <InputGroupText style={{ cursor: "pointer" ,backgroundColor:"transparent", color:"gold" , border:"none" }} onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                   </InputGroupText>
                    </InputGroup>
                    {validation.touched.password &&
                    validation.errors.password ? (
                      <FormFeedback type="invalid">
                        {validation.errors.password}
                      </FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-4" style={{ opacity: 1 }}>
                    {/* <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                        </div> */}
                    <FormGroup>
                      <Label className="form-label" style={{ fontSize: "19px", fontWeight: "bold", color: "white" }}>Company</Label>
                      <Select
                        name="company"
                        value={Companyvalue}
                        options={companyhelp}
                        onChange={value => {
                          console.log(value.value)
                          setCompanyvalue(value)
                          // Getbuyervaleu(value.value)
                          localStorage.setItem("company", JSON.stringify(value))
                        }}

                        styles={customStyles}
                          
                        
                      />
                    </FormGroup>
                  </div>

                  {/* <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div> */}

                  <div className="mt-5" style={{ opacity: 1 }}>
                    <button
                      className="btn  btn-outline-primary w-100 waves-effect waves-light"
                      type="submit"
                      style={{
                        borderColor: "gold", // Set the border color to gold
                        color: "gold",
                        transition:
                          "background-color 0.3s ease, color 0.3s ease",
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.backgroundColor = "gold"
                        e.currentTarget.style.color = "black" // Change text color for contrast
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.backgroundColor = "transparent"
                        e.currentTarget.style.color = "gold"
                      }}
                      onClick={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      Log In
                    </button>
                  </div>

                  {/* <div className="mt-4 text-center">
                        <h5 className="font-size-14 mb-3">Sign in with</h5>

                        <ul className="list-inline">
                          <li className="list-inline-item">
                            <FacebookLogin
                              appId={facebook.APP_ID}
                              autoLoad={false}
                              callback={facebookResponse}
                              render={renderProps => (
                                <Link
                                to="#"
                                  className="social-list-item bg-primary text-white border-primary"
                                  onClick={renderProps.onClick}
                                >
                                  <i className="mdi mdi-facebook" />
                                </Link>
                              )}
                            />
                          </li>
                          {google.CLIENT_ID !== '' &&
                          <li className="list-inline-item">
                            <GoogleLogin
                              clientId={google.CLIENT_ID}
                              render={renderProps => (
                                <Link
                                to="#"
                                  className="social-list-item bg-danger text-white border-danger"
                                  onClick={renderProps.onClick}
                                >
                                  <i className="mdi mdi-google" />
                                </Link>
                              )}
                              onSuccess={googleResponse}
                              onFailure={() => {}}
                            />
                          </li>
                          }
                        </ul>
                      </div> */}

                  {/* <div className="mt-4 text-center">
                        <p className="mb-0">Don&apos;t have an account ? <a href="/register" className="fw-medium text-primary"> Signup now </a> </p>
                      </div> */}

                  {/* </Form> */}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col style={{
       backgroundImage: `url(${loginbg})`,
       backgroundPosition: "center",
       backgroundSize: "cover",
       width: "100vw",
       height: "100vh",
        
      }}>

          </Col>
        </Row>
      </Container>

      {loginfaild ? (
        <SweetAlert
          title=" Invalid User Code And Password"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setloginfaild(false)
          }}
        ></SweetAlert>
      ) : null}
    </>
  )
}

// export default withRouter(Login);
export default Login

// Login.propTypes = {
//   error: PropTypes.any,
//   history: PropTypes.object,
//   loginUser: PropTypes.func,
//   socialLogin: PropTypes.func
// }
